import _ from "lodash";
import { MAPPING_TOGGLES_ENABLED_DEFAULT_VALUE } from "src/constants";
import { State } from "src/state";

export const getMetadataFrontEndConfig = (state: State) =>
  state.metadata.frontEndConfig;

export const getMetadataUploadFormConfig = (state: State) =>
  state.metadata.frontEndConfig && state.metadata.frontEndConfig.uploadForm;

export const dateFormat = (state: State) =>
  state.clientMetadata.regionalDateFormat;

export const shouldDisplayCF = (state: State) =>
  state.clientMetadata.cashFlowEnabled;

export const getMetadataAboutPageConfig = (state: State) =>
  state.metadata.frontEndConfig && state.metadata.frontEndConfig.aboutPage;

export const getMetadataPaginationPageSize = (state: State) =>
  state.config && state.config.pageSize;

export const getMappingTogglesEnabled = (state: State): any => {
  const rawConfig =
    state.metadata.frontEndConfig &&
    state.metadata.frontEndConfig.rawConfig &&
    state.metadata.frontEndConfig.rawConfig;

  const qaTeams = state.user.user.qaTeams;

  const configValues: any =
    rawConfig &&
    rawConfig.mappingTogglesConfig &&
    rawConfig.mappingTogglesConfig.values &&
    rawConfig.mappingTogglesConfig.values.length > 0 &&
    rawConfig.mappingTogglesConfig.values;

  if (configValues) {
    return (
      _.intersection(qaTeams, configValues || []).length > 0 ||
      configValues[0] === "true"
    );
  } else {
    return MAPPING_TOGGLES_ENABLED_DEFAULT_VALUE;
  }
};



// WEBPACK FOOTER //
// ./src/metadata/selector.ts